import React from 'react';
import PropTypes from 'prop-types';

import {
    Spacer,
    Table,
    Text,
} from '@zillow/constellation';

import SpinnerContainer from 'app/shared/components/SpinnerContainer';

const propTypes = {
    headerList: PropTypes.array.isRequired,
    rowList: PropTypes.array.isRequired,
    emptyMessage: PropTypes.string.isRequired,
    errorMessage: PropTypes.string,
    isLoading: PropTypes.bool,
    alignRight: PropTypes.bool,
    isEstimate: PropTypes.bool,
};

const defaultProps = {
    errorMessage: '',
    isLoading: false,
    alignRight: true,
    isEstimate: false,
};

function getAlign(index, alignRight) {
    if (index === 0) {
        return 'left';
    }
    if (alignRight) {
        return 'right';
    }
    return 'left';
}

function Error({ message }) {
    return (
        <Spacer paddingY="sm">
            <Text as="div" fontType="finePrint">
                {message}
            </Text>
        </Spacer>
    );
}

function Header({ header = [], alignRight }) {
    return (
        <Table.Header>
            <Table.Row>
                {header.map((headerItem, index) => (
                    <Table.HeaderCell key={index} align={getAlign(index, alignRight)}>
                        {headerItem}
                    </Table.HeaderCell>
                ))}
            </Table.Row>
        </Table.Header>
    );
}

function AnalyticsRow({ row = {}, alignRight }) {
    return (
        <Table.Row>
            {Object.keys(row).map((key, index) => (
                <Table.Cell key={key} align={getAlign(index, alignRight)}>
                    {row[key]}
                </Table.Cell>
            ))}
        </Table.Row>
    );
}

const AnalyticsTable = ({
    headerList,
    rowList,
    errorMessage,
    emptyMessage,
    isLoading,
    alignRight,
    isEstimate,
}) => {
    if (isLoading) {
        return <SpinnerContainer />;
    }

    if (errorMessage) {
        return <Error message={errorMessage} />;
    }

    return (
        <div>
            <Table appearance="horizontal" aria-label="Medium-sized horizontal table" size="md">
                <Header header={headerList} alignRight={alignRight} />
                <Table.Body>
                    {rowList.map((row, index) => <AnalyticsRow key={index} row={row} alignRight={alignRight} />)}
                </Table.Body>
            </Table>
            {(rowList && rowList.length === 0) &&
                <Error message={emptyMessage} />
            }
            {isEstimate && (
                <Spacer paddingY="sm">
                    <Text fontType="finePrint">
                        These numbers are an estimate. Finalized numbers will appear on your invoice.
                    </Text>
                </Spacer>
            )}
        </div>
    );
};

AnalyticsTable.propTypes = propTypes;
AnalyticsTable.defaultProps = defaultProps;

export default AnalyticsTable;
